// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-header {
    background-color: transparent !important;
}

.backButtonLink {
    border: none !important;
    background: transparent !important;
    color: blue !important;
    box-shadow: none !important;
}

.backButtonLink:hover {
    border: none !important;
    background: transparent !important;
    color: #8432f0 !important;
    box-shadow: none !important;
}
.logo {
    position: relative;
    top: 0;
    left: 0;
}
.inputheight {
    height: auto !important;
}
.paddingleft {
    padding-left: 40px;
}

.rules__heading {
    color: #151515;
    font-weight: 700;
}
.rules__rule--error {
    content: 'fa fa-add';
}
.rules__rule {
    background-position: 0 10px;
    background-repeat: no-repeat;
    list-style: none;
    padding: 10px 10px 0 22px;
}
.rules__rule--success {
    content: 'fa fa-add';
}

.paddingtop {
    padding-top: 40px;
}
.paddingtop10 {
    padding-top: 10px;
}

.paddingbottom10 {
    padding-bottom: 10px;
}

.is-invalid {
    border-left: solid 6px red;
}

.material-icons {
    display: inline-flex;
    vertical-align: middle;
}

.pac-container {
    z-index: 1001 !important;
}

.form-signin {
    max-width: 330px;
    padding: 15px;
}

@font-face {
    font-family: 'cabrion';
    src: url('Cabrion-Light.otf');
}
* {
    font-family: 'cabrion';
}
.login-wrapper {
    background: url('bg.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}

.login-card {
    padding: 100px 55px;
}

.fs-36 {
    font-size: 36px;
}
.fs-24 {
    font-size: 24px;
}

.fw-bold {
    font-weight: bold;
}
.text-gray {
    color: #a6a1b7;
}
.form-control {
    height: 55px;
    font-size: 18px;
}

.fs-14 {
    font-size: 14px;
}

.text-blue {
    color: #0f2d47;
}
.btn-blue {
    background-color: #0f2d47 !important;
    color: white !important;
    border-radius: 5px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

@media screen and (max-width: 1366.98px) {
    .login-wrapper {
        padding-top: 100px;
        padding-bottom: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .w-75 {
        width: 100% !important;
        margin: auto;
    }
    .logo {
        width: 200px;
        position: relative;
    }
    .login-card {
        padding: 50px 30px;
    }
}
.password-field-container {
    position: relative;

    .password-toggle {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        color: #666;
        z-index: 1;

        &:hover {
            color: #333;
        }

        i {
            font-size: 18px;
        }
    }
}

.form-floating > .password-field-container > .form-control {
    padding-right: 40px;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/login/reset-password/reset-password.component.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;AAC5C;;AAEA;IACI,uBAAuB;IACvB,kCAAkC;IAClC,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,kCAAkC;IAClC,yBAAyB;IACzB,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,6BAAmD;AACvD;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAgD;IAChD,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B;IAC3B,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI;QACI,kBAAkB;QAClB,qBAAqB;QACrB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,sBAAsB;QACtB,YAAY;IAChB;IACA;QACI,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;AACJ;AACA;IACI,kBAAkB;;IAElB;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;QACR,2BAA2B;QAC3B,eAAe;QACf,WAAW;QACX,UAAU;;QAEV;YACI,WAAW;QACf;;QAEA;YACI,eAAe;QACnB;IACJ;AACJ;;AAEA;IACI,mBAAmB;AACvB;AACA,wlMAAwlM","sourcesContent":[".card-header {\n    background-color: transparent !important;\n}\n\n.backButtonLink {\n    border: none !important;\n    background: transparent !important;\n    color: blue !important;\n    box-shadow: none !important;\n}\n\n.backButtonLink:hover {\n    border: none !important;\n    background: transparent !important;\n    color: #8432f0 !important;\n    box-shadow: none !important;\n}\n.logo {\n    position: relative;\n    top: 0;\n    left: 0;\n}\n.inputheight {\n    height: auto !important;\n}\n.paddingleft {\n    padding-left: 40px;\n}\n\n.rules__heading {\n    color: #151515;\n    font-weight: 700;\n}\n.rules__rule--error {\n    content: 'fa fa-add';\n}\n.rules__rule {\n    background-position: 0 10px;\n    background-repeat: no-repeat;\n    list-style: none;\n    padding: 10px 10px 0 22px;\n}\n.rules__rule--success {\n    content: 'fa fa-add';\n}\n\n.paddingtop {\n    padding-top: 40px;\n}\n.paddingtop10 {\n    padding-top: 10px;\n}\n\n.paddingbottom10 {\n    padding-bottom: 10px;\n}\n\n.is-invalid {\n    border-left: solid 6px red;\n}\n\n.material-icons {\n    display: inline-flex;\n    vertical-align: middle;\n}\n\n.pac-container {\n    z-index: 1001 !important;\n}\n\n.form-signin {\n    max-width: 330px;\n    padding: 15px;\n}\n\n@font-face {\n    font-family: 'cabrion';\n    src: url('../../../assets/fonts/Cabrion-Light.otf');\n}\n* {\n    font-family: 'cabrion';\n}\n.login-wrapper {\n    background: url('../../../assets/images/bg.png');\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n    min-height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.login-card {\n    padding: 100px 55px;\n}\n\n.fs-36 {\n    font-size: 36px;\n}\n.fs-24 {\n    font-size: 24px;\n}\n\n.fw-bold {\n    font-weight: bold;\n}\n.text-gray {\n    color: #a6a1b7;\n}\n.form-control {\n    height: 55px;\n    font-size: 18px;\n}\n\n.fs-14 {\n    font-size: 14px;\n}\n\n.text-blue {\n    color: #0f2d47;\n}\n.btn-blue {\n    background-color: #0f2d47 !important;\n    color: white !important;\n    border-radius: 5px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n@media screen and (max-width: 1366.98px) {\n    .login-wrapper {\n        padding-top: 100px;\n        padding-bottom: 100px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    .w-75 {\n        width: 100% !important;\n        margin: auto;\n    }\n    .logo {\n        width: 200px;\n        position: relative;\n    }\n    .login-card {\n        padding: 50px 30px;\n    }\n}\n.password-field-container {\n    position: relative;\n\n    .password-toggle {\n        position: absolute;\n        right: 12px;\n        top: 50%;\n        transform: translateY(-50%);\n        cursor: pointer;\n        color: #666;\n        z-index: 1;\n\n        &:hover {\n            color: #333;\n        }\n\n        i {\n            font-size: 18px;\n        }\n    }\n}\n\n.form-floating > .password-field-container > .form-control {\n    padding-right: 40px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
